import { PropsWithChildren, useContext } from "react";
import { RsaContext, encrypt, useCryptoKey } from "./RsaContext.Parts";

export const RsaProvider = ({ children }: PropsWithChildren) => {
  const cryptoKey = useCryptoKey();

  const rsaEncrypt = (value: string) => encrypt(value, cryptoKey);

  return (
    <RsaContext.Provider value={{ rsaEncrypt }}>{children}</RsaContext.Provider>
  );
};

export const useRsaContext = () => {
  const context = useContext(RsaContext);
  if (!context) {
    throw new Error("useRsaContext must be used within a RsaProvider");
  }
  return context;
};
